module.exports = __webpack_public_path__ + "img/piraten-logo.f2b7d2ef.svg";